/* eslint-disable consistent-return */
import React from 'react';
import { Button } from 'cvlib';
import './alert.scss';
import { useAlertRimender } from './hooks/useAlertReminder';

const AlertReminder = () => {
  const {
    reminder_alert_description_futureEvent_label,
    reminder_alert_option_button_tuneinPlay,
    reminder_alert_option_button_close,
    handleWatchReminder,
    handleCloseReminder,
    schedule,
    logo,
    title,
    channel,
    show,
    userHash,
  } = useAlertRimender();

  if (!show || !userHash) return <></>;

  return (
    <>
      <div className="alertReminder--back" />
      <div className="alertPop alertReminder">
        <div className="alertPop--container">
          <div className="alertPop--message">
            <span>{reminder_alert_description_futureEvent_label}</span>
            <span style={{ fontWeight: 'bold' }}>
              {(title.current?.length <= 15 && title?.current) ||
                `${title.current?.substring(0, 12)}...`}
            </span>
            <span>|</span>
            <span style={{ fontWeight: 'bold' }}>{channel?.current}</span>
            <img src={logo?.current} alt="logo" style={{ width: '80px' }} />
            <span>{schedule?.current}</span>
          </div>
        </div>
        <div className="buttonCont">
          <Button type="red" onClick={handleWatchReminder}>
            {reminder_alert_option_button_tuneinPlay}
          </Button>
        </div>
        <div className="buttonCont">
          <Button type="gray" onClick={handleCloseReminder}>
            {reminder_alert_option_button_close}
          </Button>
        </div>
      </div>
    </>
  );
};

export default AlertReminder;
